// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2s83p","range":"MonthRangeSwitch_range__2xafZ","disabled":"MonthRangeSwitch_disabled__3-HpO"};